module.exports = __webpack_public_path__ + "img/about-logo-dark.92abbd0d.png";